module.exports = __webpack_public_path__ + "static/media/myriad-pro-light.4e2217c1.otf";